enum PopupTypes {
    Advertising = 'advertising',
    Normal = 'normal',
}

export default PopupTypes;
